<template>
  <div v-if="data" class="contentful-spacer" :style="style"></div>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import useResize from '@/compositions/useResize.js';
import { computed } from 'vue';

export default {
  props: contentfulProps,
  async setup(p, c) {
    const { data, init } = useContentful('pageComponentSpacer', p, c);
    const { width } = useResize();

    const style = computed(() => {
      if (!data.value) {
        return '';
      }
      let space = data.value.space320px;
      if (width.value > 1800) {
        space = data.value.space1800px;
      } else if (width.value > 1400) {
        space = data.value.space1400px;
      } else if (width.value > 1200) {
        space = data.value.space1200px;
      } else if (width.value > 768) {
        space = data.value.space768px;
      }
      return `margin-top:${space};`;
    });

    await init()

    return { data, style };
  },
};
</script>

<style lang="postcss">
.contentful-spacer {
  margin: 0;
  padding: 0;
}
</style>
